import styled from "styled-components";
import format from "date-fns/format";
import removeTimezone from "../../../utils/removeTimezone";
import { useAlly } from "../../../context/ally";
import m from "../../../styles/molanturTheme";
import { Card, Dialog, IconButton, TourThumb, clp } from "../ui";

// Resumen de lo reservado en este flujo: cada tour enviado, con editar y borrar.
export default function Summary() {
    const { summary, setIsSummaryModalOpen, setEditReservationId, setConfirmDeleteReservationId } = useAlly()
    return (
        <Dialog title="Resumen" onClose={() => setIsSummaryModalOpen(false)}>
            <List>
                {
                    summary.map((item, idx) => (
                        <Card key={idx} $pad={12} className="item">
                            <TourThumb tourId={item.reservation.tour_id} />
                            <div className="info">
                                <strong>{item.reservation.tour_id}</strong>
                                <span>{item.passenger.name}</span>
                                <span className="meta">
                                    <span>{typeof item.reservation.reservation_date === 'string' ? removeTimezone(item.reservation.reservation_date) : format(item.reservation.reservation_date, 'dd/MM/yyyy')}</span>
                                    {' · '}
                                    <span>{clp(item.reservation.price)}</span>
                                    {' · '}
                                    <span>{item.reservation.ticket_included ? 'Entradas incluidas' : 'Pagan en el parque'}</span>
                                </span>
                            </div>
                            <div className="actions">
                                <IconButton name="edit" label={`Editar ${item.reservation.tour_id} de ${item.passenger.name}`} size={40}
                                    onClick={() => setEditReservationId(item.reservation.id)} />
                                <IconButton name="trash" label={`Borrar ${item.reservation.tour_id} de ${item.passenger.name}`} size={40} className="delete"
                                    onClick={() => setConfirmDeleteReservationId(item.reservation.id)} />
                            </div>
                        </Card>
                    ))
                }
            </List>
        </Dialog>
    )
}

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    .item {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 1px;
        font-size: 13.5px;
        strong {
            font-family: ${m.font.display};
            font-weight: 600;
            font-size: 16px;
        }
    }
    .meta {
        font-size: 12.5px;
        color: ${m.color.inkFaint};
    }
    .actions {
        display: flex;
        gap: 6px;
    }
    .delete { color: ${m.color.danger}; }
`
